import { FC, PropsWithChildren } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import { heIL } from "@mui/material/locale";

export const CustomThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const theme = createTheme(
    {
      direction: "rtl",
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            body: {
              margin: 0,
              padding: 0,
              minHeight: "100vh",
              boxSizing: "border-box",
              direction: "rtl",
            },
            a: {
              textDecoration: "none",
              color: "inherit",
            },
            "*": {
              direction: "rtl",
            },
            ".MuiChartsAxis-tickLabel tspan": {
              direction: "ltr !important",
            },
            // hide all elements with the class "no-print" when printing
            "@media print": {
              ".no-print": {
                display: "none !important",
              },
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
            startIcon: {
              marginLeft: 4,
              marginRight: 0,
            },
            endIcon: {
              marginLeft: 0,
              marginRight: 4,
            },
          },
        },
        MuiListItemText: {
          styleOverrides: {
            primary: {
              textAlign: "start",
            },
            secondary: {
              textAlign: "start",
            },
          },
        },
        MuiCard: {
          styleOverrides: {
            root: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            },
          },
        },
      },
    },
    heIL,
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
